module.exports = ".error-list {\n  color: red;\n  text-align: center;\n  font-size: 0.95rem;\n}\n"